const useInputChange = (setState) => {
  return (e) => {
    e.persist();
    setState((state) => ({ ...state, [e.target.name]: e.target.value }));
  };
};

export default useInputChange;
